import { render, staticRenderFns } from "./EventsModeForm.vue?vue&type=template&id=bf41f660&scoped=true&"
import script from "./EventsModeForm.vue?vue&type=script&lang=ts&"
export * from "./EventsModeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf41f660",
  null
  
)

export default component.exports